module.exports = __webpack_public_path__ + "fonts/fa-light-300.48d5b0c.woff2";